import {listGroups as list} from '@/domain/project/services/knowledgeGroup'
import window from './window/window.js'

export default {
  pageTitle: 'Grupos de Base de Conhecimento',
  columns: [
    {
      name: 'nome',
      required: true,
      label: 'Nome',
      align: 'left',
      field: 'name',
      sortable: true,
      parser: function (props) {
        return props.name
      }
    },
    {
      name: 'code',
      required: true,
      label: 'Código',
      align: 'left',
      field: 'code',
      sortable: true,
      parser: function (props) {
        return props.code
      }
    },
    {
      name: 'descricao',
      required: true,
      label: 'Descrição',
      align: 'left',
      field: 'description',
      sortable: true,
      parser: function (props) {
        return props.description
      }
    },
    {
      name: 'parent',
      required: true,
      label: 'Parente',
      align: 'left',
      field: 'parent',
      sortable: true,
      parser: function (props) {
        return props.parent ? props.parent.name : null
      }
    },
    {
      name: 'public',
      required: true,
      label: 'Público',
      align: 'left',
      field: 'public',
      sortable: true,
      parser: function (props) {
        return props.public ? 'Sim' : 'Não'
      }
    },
    {
      name: 'active',
      required: true,
      label: 'Situação',
      align: 'left',
      field: 'active',
      sortable: true,
      parser: function (props) {
        return props.active ? 'Ativo' : 'Inativo'
      }
    },
    {
      name: 'options',
      required: true,
      label: '',
      field: 'options',
      sortable: false
    }
  ],
  resolve: list,
  methods: {
    // window: window
    abrir: function (id) {
      window.call(this, {id: id, table: this.table})
    },
    novo: function () {
      window.call(this, {})
    }
  }
}
